module.exports = __webpack_public_path__ + "static/media/plan-C2a-mobile-en.2c77cc40.png";